import { render, staticRenderFns } from "./Rabatt.vue?vue&type=template&id=6249400e&"
import script from "./Rabatt.vue?vue&type=script&lang=js&"
export * from "./Rabatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports